<template>
  <label :class="['custom-checkbox', { 'checked': isChecked }]">
    <input
        type="checkbox"
        :checked="isChecked"
        @change="handleChange"
    />
    <span class="checkmark"></span>
    <span class="check-label">{{label}}</span>
  </label>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChecked: this.value
    };
  },
  watch: {
    value(newVal) {
      this.isChecked = newVal;
    }
  },
  methods: {
    handleChange(event) {
      this.isChecked = event.target.checked;
      this.$emit('input', this.isChecked);
    }
  }
};
</script>

<style scoped>
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.custom-checkbox input {
  display: none;
}
.custom-checkbox .checkmark {
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: 2px solid var(--gray-color-new);
  border-radius: 3px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.custom-checkbox.checked .checkmark {
  background-color: var(--text-primary-color-new-transparent);
  border-color: var(--primary-color-new);
}
.custom-checkbox .checkmark::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
}
.custom-checkbox.checked .checkmark::after {
  opacity: 1;
}
.check-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color-new);
}
</style>
